const handleMobileMenu = () => {
  $('.menu__item--has-dropdown').on('click', '> a', function(event) {
    if ($(window).innerWidth() <= 1023) {
      const $this = $(this);
      const $currentMenu = $this.closest('ul');
      let $nextMenu = $this.closest('li').find('ul').first();

      if ($this.closest('li').find('> .megamenu').length) {
        $nextMenu = $this.closest('li').find('.megamenu__content-body').find('ul').first();
      }

      $currentMenu.removeClass('is-current')
        .addClass('is-prev');

      $nextMenu.addClass('is-current');

      $this.closest('.nav').height($nextMenu.outerHeight());

      event.preventDefault();
    }
  });

  $('.js-nav-back').on('click', function(event) {
    const $this = $(this);
    const $currentMenu = $this.closest('.is-current');
    const $prevMenu = $this.closest('.is-prev');

    $currentMenu.removeClass('is-current');

    $prevMenu.removeClass('is-prev')
      .addClass('is-current');

    event.preventDefault();
  });
}

handleMobileMenu();
